import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import { FieldGroup } from '../FieldGroup'

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const { addSubField, group } = this.props;

		const defaultFields = [
			getFieldFactory().getNewDefaultFieldGroup('post_title', 'Post title' ),
			getFieldFactory().getNewDefaultFieldGroup('post_content', 'Post content', 'textarea' ),
			getFieldFactory().getNewDefaultFieldGroup('post_excerpt', 'Post excerpt' ),
			getFieldFactory().getNewDefaultFieldGroup('post_date', 'Post date' ),
			getFieldFactory().getNewDefaultFieldGroup('post_password', 'Post password' ),
			getFieldFactory().getNewDefaultFieldGroup('post_parent', 'Post parent' ),
			getFieldFactory().getNewDefaultFieldGroup('menu_order', 'Menu order' ),
			getFieldFactory().getStatusFieldGroup( 'select' ),
			getFieldFactory().getPostTypes( 'select' ),
			{
				name: 'post_author',
				label: 'Post author',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					{
						id: 'field-type',
						inputType: 'select',
						source: 'userFieldColumns',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Field type',
						defaultValue: 'Select a field type',
						dynamic: false
					},
					getFieldFactory().getParametersField(),
				],
			},
		];

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					<React.Fragment>
						<h3>Default Fields ({endpoint.editPost[currentItem].defaultFields.length})</h3>

						<ParametersNotice parameters={endpoint.parameters}/>

						<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{defaultFields.map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
						</select>

						<button
							onClick={() => addSubField(endpointId, defaultFields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
						>
							Add
						</button>

						<FieldGroups group={group} />

					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(DefaultFieldsFilter);
